import { MANAGEMENT_ALL_LOCATIONS_ID } from "../management-dashboard.mock";

export const MANAGEMENT_LOCATION_DETAIL_PATH = "/management/location";
export const MANAGEMENT_LOCATION_ID_QUERY_PARAM = "locationId";

/**
 * Builds the location-detail route, optionally deep-linking a concrete location.
 */
export function getManagementLocationDetailPath(locationId?: string | null): string {
  if (!locationId || locationId === MANAGEMENT_ALL_LOCATIONS_ID) {
    return MANAGEMENT_LOCATION_DETAIL_PATH;
  }
  const params = new URLSearchParams({
    [MANAGEMENT_LOCATION_ID_QUERY_PARAM]: locationId
  });
  return `${MANAGEMENT_LOCATION_DETAIL_PATH}?${params.toString()}`;
}

/**
 * Reads a location id from the location-detail search string (or null if absent / all).
 */
export function parseManagementLocationIdFromSearch(search: string): string | null {
  const raw = new URLSearchParams(search).get(MANAGEMENT_LOCATION_ID_QUERY_PARAM);
  if (!raw || raw === MANAGEMENT_ALL_LOCATIONS_ID) {
    return null;
  }
  return raw;
}
